import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ComponentsModule } from '../shared/components/components.module';

import { ReferenceRoutingModule } from './reference-routing.module';

import { ReferenceComponent } from './reference.component';



@NgModule({
  declarations: [
    ReferenceComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    ReferenceRoutingModule,
  ]
})
export class ReferenceModule { }
